import React from 'react'
import styled, { keyframes } from 'styled-components'
import { TweenLite, TimelineMax } from "gsap"

import Logo from '@components/svg/Logo'
import Soon from '@components/svg/Soon'
import { media } from '@utils/mediaQuery'

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  padding: 35px;
  z-index: 10000;
  color: white;
  font-size: 15px;
  mix-blend-mode: difference;

  ${media.xs`
    padding: 25px;
  `}

  svg {
    width: 100px;
    height: auto;
    ${media.xs`
      width: 70px;
    `}
  }

  &.dark {
    color: white;
    a {
      color: white;
    }
    svg {
      path,
      polygon {
        fill: #fff;
      }
    }
  }

  &.light {
    color: black;
    a {
      color: black;
    }
    svg {
      path,
      polygon {
        fill: #000;
      }
    }
  }
`

const HeaderElements = styled.ul`
  list-style: none;
  display: flex;
  flex-direction: row;

  ${media.xs`
    flex-direction: column;
  `}

  li {
    margin-right: 3rem;
    animation-name: ${fadeIn};
    animation-fill-mode: backwards;
    animation-duration: 2.5s;
    ${media.xs`
      margin-bottom: 10px;
    `}
    &:nth-child(1) {
      animation-delay: 0.25s;
    }
    &:nth-child(2) {
      animation-delay: 0.5s;
    }
    &:nth-child(3) {
      animation-delay: 0.75s;
    }
    &:nth-child(4) {
      animation-delay: 6.25s;
    }
    /* logo cell */
    &.logo {
      margin-left: auto;
      margin-right: 0;
      position: relative;
      ${media.xs`
        position: absolute;
        top: 25px;
        right: 25px;
      `}
    }
  }

  p {
    margin: 0;
  }

  a.phone {
    text-decoration: none;
  }

`

const SvgContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  opacity: ${props => props.opacity};
  z-index: ${props => props.zIndex};
  &.soon {
    svg {
      width: 93px;
      ${media.xs`
        width: 66px;
      `}
    }
  }
`

class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      soonState: false
    }
    this.timeline = null
    this.logoContainer = React.createRef()
    this.soonContainer = React.createRef()
 }

  render() {
    return (
      <HeaderContainer className={this.props.theme}>
        <HeaderElements className={this.props.theme}>
          {/* <li>
            <p>Moon Consultants</p>
          </li> */}
          <li>
            <p><a href="mailto:info@moonconsultants.ca">info@moonconsultants.ca</a></p>
          </li>
          <li>
            <p><a href="tel:+1 514 817 5931" className="phone">+1 514 817 5931</a></p>
          </li>
          {/* <li className={`logo`}>
            <SvgContainer className="logo__part logo" opacity={0} zIndex={1} ref={this.logoContainer}>
              <Logo />
            </SvgContainer>
            <SvgContainer className="logo__part soon" opacity={0} zIndex={2} ref={this.soonContainer}>
              <Soon />
            </SvgContainer>
          </li> */}
        </HeaderElements>
      </HeaderContainer>
    )
  }
}


export default Header